import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertCritical16Icon extends BaseIcon {
  getChildren = () => [
    <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 4c0-.6.4-1 1-1s1 .4 1 1v4c0 .6-.4 1-1 1s-1-.4-1-1V4zm1 10c-.8 0-1.5-.7-1.5-1.5S7.2 11 8 11s1.5.7 1.5 1.5S8.8 14 8 14z" fill="#f24e4e"/>
    ]
  getViewBox = () => '0 0 16 16'
}
